/**
 * The standard OrangePi coin wiring = what the image bakes into the router's
 * coin.conf on first boot (eAZy carrier): coin pulses on PA12, slot power on
 * PA11 (HIGH powers the acceptor, LOW cuts it), 50 ms debounce. Mirrors
 * STANDARD_SBC_COIN_CONFIG on the server. The server stores this set
 * explicitly on "Standard" so the heartbeat pushes it — a null config sends
 * the router nothing and a custom pin would stay forever (ORP-156D9B4D,
 * 2026-10-12: stuck on PA6, Standard changed nothing).
 */
export const STANDARD_COIN_WIRING = Object.freeze({
   gpioLine: 'PA12',
   setLine: 'PA11',
   setOpen: '1',
   setClosed: '0',
   debounceMs: 50,
});

export interface CoinWiringLike {
   gpioLine?: string | null;
   setLine?: string | null;
   setOpen?: string | null;
   setClosed?: string | null;
   debounceMs?: number | string | null;
}

/** Nothing saved, the explicit standard set, or blanks-for-default all mean Standard. */
export function isStandardCoinWiring(cfg: CoinWiringLike | null | undefined): boolean {
   if (!cfg) return true;
   const s = STANDARD_COIN_WIRING;
   const gpio = (cfg.gpioLine ?? '').trim();
   const set = (cfg.setLine ?? '').trim();
   const open = (cfg.setOpen ?? '').trim();
   const closed = (cfg.setClosed ?? '').trim();
   const db = cfg.debounceMs == null || cfg.debounceMs === '' ? null : Number(cfg.debounceMs);
   return (
      (gpio === '' || gpio === s.gpioLine) &&
      set === s.setLine &&
      (open === '' || open === s.setOpen) &&
      (closed === '' || closed === s.setClosed) &&
      (db === null || db === s.debounceMs)
   );
}
